import React, { useEffect, useState, useRef, useContext } from "react";
import { useLazyQuery, useMutation, useQuery } from "@apollo/react-hooks";
import styles from "../Boombassador/Boombassador.module.scss";
import boombassador from "../../images/boombassador.png";
import addLogIcon from "../../images/addLogIcon.png";
import badge from "../../images/badge.png";
import loaderBoomer from "../../images/loader-boomer.png";
import * as Icon from "react-feather";
import {
  SEARCH_STUDENTS_FOR_BOOMBASSADOR,
  SELECTED_STUDENT_FROM_BOOMBASSADOR_SEARCH,
  ACCEPT_BOOMBASSADOR_ROLE,
} from "./services/graphql";
import { AuthContext } from "../../services/user/AuthProvider";
import { navigate } from "@reach/router";
import AddLogAsBoombassador from "../Boombassador/components/AddLogAsBoombassador";
import BoombassadorAccept from "../Boombassador/components/BoomambassadorAccept";
import ReadingBookItem from "./../Dashboard/components/ReadingBookItem";
import _ from "lodash";
import "@reach/dialog/styles.css";
import { Dialog } from "@reach/dialog";
import { Tooltip } from 'react-tippy';

const Boombassador = ({ location }) => {
  const [results, setResults] = useState([]);
  const [noStudents, setNoStudents] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const intervalRef = useRef(null);
  const { currentUser, setCurrentUser } = useContext(AuthContext);
  const [recentLoggedStudents, setRecentLoggedStudents] = useState(
    currentUser.recentLoggedStudents || []
  );
  const [hasSearched, setHasSearched] = useState(false);
  const [showAcceptDialog, setShowAcceptDialog] = useState(
    !currentUser.boombassadorAccepted
  );
  const [acceptRole] = useMutation(ACCEPT_BOOMBASSADOR_ROLE, {
    onCompleted: (data) => {
      if (data?.acceptBoombassadorRole?.accepted) {
        setShowAcceptDialog(false);
        const updatedUser = {
          ...currentUser,
          boombassadorAccepted: true,
        };
        setCurrentUser(updatedUser);
      } else {
        navigate("/boombassador");
      }
    },
  });

  const [searchStudents, { loading, error }] = useLazyQuery(
    SEARCH_STUDENTS_FOR_BOOMBASSADOR,
    {
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        if (data && data.studentsSearchForBoombassador) {
          const students = data.studentsSearchForBoombassador;
          setResults(students);
          setNoStudents(students.length === 0);
        }
      },
    }
  );

  const isLogsPage = location?.pathname?.endsWith("/logs");
  const clickedStudent = location?.state?.student || null;
  const {
    data: selectedStudentData,
    loading: selectedStudentLoading,
    error: selectedStudentError,
  } = useQuery(SELECTED_STUDENT_FROM_BOOMBASSADOR_SEARCH, {
    skip: !isLogsPage || !clickedStudent,
    variables: {
      name: clickedStudent
        ? `${clickedStudent.firstName} ${clickedStudent.lastName}`.trim()
        : "",
    },
    fetchPolicy: "network-only",
  });
  const selectedStudent = selectedStudentData?.studentsSearchForBoombassador?.find(
    (student) => student.id === clickedStudent?.id
  );

  const handleStudentClick = (student) => {
    navigate("/boombassador/logs", { state: { student } });
  };

  useEffect(() => {
    if (searchTerm && searchTerm.length > 1) {
      intervalRef.current = setTimeout(() => {
        setHasSearched(true);
        searchStudents({ variables: { name: searchTerm } });
      }, 600);
    } else {
      setResults([]);
      setNoStudents(false);
      if (intervalRef.current) clearTimeout(intervalRef.current);
    }

    return () => {
      if (intervalRef.current) clearTimeout(intervalRef.current);
    };
  }, [searchTerm, searchStudents]);

  useEffect(() => {
    if (!isLogsPage) {
      setSearchTerm("");
      setResults([]);
      setNoStudents(false);
      if (intervalRef.current) clearTimeout(intervalRef.current);
    }
  }, [isLogsPage]);

  const progress = Math.min((currentUser.boombassadorCounter / 100) * 100, 100);

  return (
    <div className="page-wrapper">
      <div className="page-wrapper__main">
        <div className={styles.headerContainer}>
          <div className={`${styles.boombassadorLogo} ${styles.mr}`}>
            <img src={boombassador} alt="Boombassador" />
          </div>
          {isLogsPage && clickedStudent && (
            <AddLogAsBoombassador student={selectedStudent || clickedStudent} />
          )}
        </div>

        <div className="content-panel">
          {!isLogsPage ? (
            <>
              <div className={styles.wrapper}>
                <div className={styles.inputBox}>
                  <input
                    type="text"
                    placeholder="Search Student Name"
                    className={styles.input}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                  <span className={styles.icon}>
                    <Icon.Search />
                  </span>
                </div>
              </div>

              {!isLogsPage &&
                !hasSearched &&
                recentLoggedStudents.length > 0 && (
                  <>
                    <div className={styles.recentSearch}>
                      <Icon.Clock />
                      <span>Recent Search Results</span>
                    </div>

                    <div className={styles.resultsList}>
                      {recentLoggedStudents.map((student) => {
                        const name = `${student.firstName} ${student.lastName}`;
                        const className =
                          student.classes?.[0]?.name ??
                          student.class?.name ??
                          "";

                        return (
                          <div
                            key={`recent-${student.id}`}
                            className={`${styles.studentRow} ${styles.disabledStudents}`}
                          >
                            <div className={styles.studentInfo}>
                              <div className={styles.studentAvatar}>
                                <img
                                  src={student.boomerAvatarUrl || loaderBoomer}
                                  alt={name}
                                />
                              </div>
                            </div>

                            <div className={styles.studentName}>{name}</div>

                            <div className={styles.studentClass}>
                              {className && `Class ${className}`}
                            </div>

                            <img
                              src={addLogIcon}
                              alt="addLogIcon"
                              className={styles.bookButton}
                            />
                          </div>
                        );
                      })}
                    </div>
                  </>
                )}

              <div className={styles.resultsList}>
                {loading && <div className={styles.infoText}>Searching…</div>}
                {error && (
                  <div className={styles.infoText}>
                    Something went wrong. Please try again.
                  </div>
                )}
                {noStudents && !loading && (
                  <div className={styles.infoText}>No students found.</div>
                )}

                {!loading &&
                  !noStudents &&
                  results.map((student) => {
                    const name = `${student.firstName} ${student.lastName}`;
                    const className =
                      student.classes?.[0]?.name ?? student.class?.name ?? "";

                    return (
                      <div key={student.id} className={styles.studentRow}>
                        <div className={styles.studentInfo}>
                          <div className={styles.studentAvatar}>
                            <img
                              src={student.boomerAvatarUrl || loaderBoomer}
                              alt={name}
                            />
                          </div>
                        </div>
                        <div className={styles.studentName}>{name}</div>

                        <div className={styles.studentClass}>
                          {className && `Class ${className}`}
                        </div>
                        <img
                          src={addLogIcon}
                          alt="addLogIcon"
                          className={styles.bookButton}
                          onClick={() => handleStudentClick(student)}
                        />
                      </div>
                    );
                  })}
              </div>
            </>
          ) : (
            <div className={styles.bookList}>
              {selectedStudentLoading && (
                <div className={styles.infoText}>Loading books…</div>
              )}
              {selectedStudentError && (
                <div className={styles.infoText}>
                  Something went wrong. Please try again.
                </div>
              )}
              {!selectedStudentLoading && !selectedStudentError && !selectedStudent && (
                <div className={styles.infoText}>No student found.</div>
              )}
              {!selectedStudentLoading && !selectedStudentError && selectedStudent && _.orderBy(
                (selectedStudent.uncompletedBooks || []).filter(
                  (c) => c.bookType !== 4 && (c.status === 0 || c.status === 1)
                ),
                "book.title",
                "asc"
              ).map((book) => (
                <ReadingBookItem
                  key={`book-${book.id}`}
                  book={book.book}
                  readingBook={book}
                />
              ))}
            </div>
          )}
        </div>
      </div>

      <div className="page-wrapper__side">
        <div className={styles.sideStats}>
          <div>
            <h1 className={styles.boombassadorTitle}>
              Your Boombassador LogBook
            </h1>

            <div>
              <div
                className={styles.infoCard}
                style={{ backgroundColor: "#9DC030" }}
              >
                <span>Number of logs today</span>
                <div className={styles.infoCounter}>
                  {currentUser?.dailyBoombassadorStats?.dailyStats ?? 0}
                </div>
              </div>

              <div
                className={styles.infoCard}
                style={{ backgroundColor: "#C76EFF" }}
              >
                <span>Number of logs this week</span>
                <div className={styles.infoCounter}>
                  {currentUser?.dailyBoombassadorStats?.weeklyStats ?? 0}
                </div>
              </div>

              <div
                className={styles.infoCard}
                style={{ backgroundColor: "#0BBEDB" }}
              >
                <span>Number of logs this year</span>
                <div className={styles.infoCounter}>
                  {currentUser?.dailyBoombassadorStats?.yearlyStats ?? 0}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.sidebadges}>
          <h1 className={styles.boombassadorTitle}>Your Boombassador Badges</h1>

          <div className={styles.badgeProgress}>
            <div className={styles.track}>
              <div
                className={styles.trackFill}
                style={{ width: `${progress}%` }}
              />
              <span className={styles.divider} style={{ left: "25%" }} />
              <span className={styles.divider} style={{ left: "50%" }} />
              <span className={styles.divider} style={{ left: "75%" }} />
            </div>

            <div className={styles.badges}>
              <div
                className={`${styles.badge} ${
                  progress >= 25 ? styles.active : ""
                }`}
                style={{ left: "25%" }}
              >
                <Tooltip title="25" size="big"><div className={`${styles.token} ${styles.bronze}`}>
                  <img className={styles.tokenImg} src={badge} alt="" />
                </div></Tooltip>
              </div>

              <div
                className={`${styles.badge} ${
                  progress >= 50 ? styles.active : ""
                }`}
                style={{ left: "50%" }}
              >
                <Tooltip title="50" size="big"><div className={`${styles.token} ${styles.silver}`}>
                  <img className={styles.tokenImg} src={badge} alt="" />
                </div></Tooltip>
              </div>

              <div
                className={`${styles.badge} ${
                  progress >= 75 ? styles.active : ""
                }`}
                style={{ left: "75%" }}
              >
                <Tooltip title="75" size="big"><div className={`${styles.token} ${styles.gold}`}>
                  <img className={styles.tokenImg} src={badge} alt="" />
                </div></Tooltip>
              </div>

              <div
                className={`${styles.badge} ${
                  progress >= 100 ? styles.active : ""
                }`}
                style={{ left: "100%" }}
              >
                <Tooltip title="100" size="big"><div className={`${styles.token} ${styles.diamond}`}>
                  <img className={styles.tokenImg} src={badge} alt="" />
                </div></Tooltip>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showAcceptDialog && (
        <Dialog aria-label="Modal" isOpen={showAcceptDialog}>
          <BoombassadorAccept onAgree={acceptRole} />
        </Dialog>
      )}
    </div>
  );
};

export default Boombassador;
